import $ from '@modules/jquery-import';

const Events = {
    bind: function () {
        if ( !this.__events__ ) {
            this.__events__ = $( {} );
        }
        this.__events__.on.apply( this.__events__, arguments );
    },
    unbind: function () {
        if ( !this.__events__ ) {
            this.__events__ = $( {} );
        }
        this.__events__.off.apply( this.__events__, arguments );
    },
    one: function () {
        if ( !this.__events__ ) {
            this.__events__ = $( {} );
        }
        this.__events__.one.apply( this.__events__, arguments );
    },
    trigger: function () {
        if ( !this.__events__ ) {
            this.__events__ = $( {} );
        }
        this.__events__.trigger.apply( this.__events__, arguments );
    },

    is_enter_key: function ( e ) {
        return ((typeof e.which == 'number') ? e.which : e.keyCode) === 13;
    },

    is_tab_key: function ( e ) {
        return ((typeof e.which == 'number') ? e.which : e.keyCode) === 9;
    }
};

export default Events;
